/**
 * Local storage keys
 */
export const STORAGE_KEYS = {
  /** Legacy, from when tabs shared one session: removed on load, never written or read. */
  AUTH_TOKEN: 'sf-auth-token',
  /** Legacy, like AUTH_TOKEN. */
  USER: 'sf-user',
  THEME: 'sf-theme',
};

/** sessionStorage — Better Auth OAuth + app session exchange UX */
export const SESSION_AUTH_KEYS = {
  IN_PROGRESS: 'auth_in_progress',
  /** User left our origin mid–sign-in (e.g. redirect to Google). Survives the round-trip. */
  OAUTH_DEPARTED_ORIGIN: 'oauth_departed_origin',
  /** Where to send the user after a successful login (survives OAuth round-trip). */
  REDIRECT: 'auth_redirect',
} as const;

export function clearSessionAuthMarkers() {
  // Typed locally so this compiles in the worker too, which has no DOM types.
  const storage = (globalThis as { sessionStorage?: { removeItem(key: string): void } }).sessionStorage;
  if (typeof storage === 'undefined') return;
  storage.removeItem(SESSION_AUTH_KEYS.IN_PROGRESS);
  storage.removeItem(SESSION_AUTH_KEYS.OAUTH_DEPARTED_ORIGIN);
}

/**
 * Pagination defaults
 */
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 100,
};

/**
 * Date formats
 */
export const DATE_FORMATS = {
  DISPLAY: 'MMMM d, yyyy',
  ISO: 'yyyy-MM-dd',
  DATETIME: 'yyyy-MM-dd HH:mm:ss',
};

/**
 * Error messages
 */
export const ERROR_MESSAGES = {
  UNAUTHORIZED: 'You are not authorized to perform this action',
  NOT_FOUND: 'The requested resource was not found',
  SERVER_ERROR: 'An unexpected error occurred. Please try again later',
  VALIDATION_ERROR: 'Please check your input and try again',
  CONNECTION_ERROR: 'Could not connect to the server. Please check your internet connection',
};
